/* ELLESANTI V3 · «Guardiamo che cosa fa una forma.»: i sei momenti (19/10/2026, sera, v5).
   DESKTOP: lo scroll della pagina non viene intercettato. Il riquadro resta fermo (sticky) e la fila si muove in continuo con lo scroll.
   Mai a metà: quando lo scroll si ferma con la fila fra due card, la pagina scivola da sola sulla card più vicina nella direzione
   in cui si stava andando (basta un quarto di passo). Se si riprende a scorrere durante lo scivolamento, vince lo scroll.
   Sosta: la prima card resta ferma un breve tratto all'inizio, l'ultima un passo intero alla fine.
   I testi compaiono solo quando la fila è ferma su una card. Menu nascosto mentre la sezione è ferma (html.e-msc-zona).
   Mouse: vince lo scroll; una card va in primo piano solo con un movimento vero del mouse (14 px), lontano dallo scroll (0,5 s).
   MOBILE (sotto 1024 px, .is-swipe): niente sezione ferma, la fila si scorre con lo swipe (scroll-snap, una card per volta).
   La pagina scorre normalmente in verticale. La card agganciata è quella attiva e solo lei mostra i testi, in sequenza.
   Tocco su una card non attiva = la porta in primo piano. «Riduci movimento»: fila scorrevole con testi visibili. */
(function () {
  var RM = matchMedia('(prefers-reduced-motion: reduce)'), DESK = matchMedia('(min-width: 1024px)');
  var HOVER = matchMedia('(hover: hover) and (pointer: fine)');
  var HOVER_MS = 160, HOVER_PX = 14, CALMA = 500, FOLLOW = 0.14, FERMA = 0.12, STOP = 160, SPINTA = 0.25;
  var SOSTA_INIZIO = 0.3, SOSTA_FINE = 1;
  function listen(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); }
  function ease(k) { return k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2; }
  function now() { return Date.now(); }

  function init(sec) {
    if (sec._msc) return;
    sec._msc = true;
    var H = document.documentElement, pin = sec.querySelector('.e-msc__pin'), vp = sec.querySelector('.e-msc__vp');
    var track = sec.querySelector('.e-msc__track');
    var cards = Array.prototype.slice.call(track.querySelectorAll('.e-msc__card')), n = cards.length;
    if (!n) return;
    var wa = parseFloat(sec.getAttribute('data-wa')) || 56, ws = parseFloat(sec.getAttribute('data-ws')) || 20;
    var wm = parseFloat(sec.getAttribute('data-wm')) || 85, passo = parseFloat(sec.getAttribute('data-passo')) || 70;
    var cur = -1, step = 0, off0 = 0, maxP = 0, on = false, swipe = false, auto = 0;
    var fd = 0, target = 0, loop = 0, lastScroll = 0, lastY = pageYOffset, dir = 1, stopT = 0, swT = 0;

    function gap() { var g = parseFloat(getComputedStyle(track).columnGap); return isNaN(g) ? 0 : g; }
    function setActive(a2) {
      if (a2 === cur) return;
      cur = a2;
      cards.forEach(function (c, i) { c.classList.toggle('is-active', i === a2); });
    }
    function render(f) {
      var W = track.clientWidth, g = gap(), x;
      if (DESK.matches) {
        var s = W * ws / 100, a = Math.max(W * wa / 100, W - (n - 1 - f) * (s + g)), left = 0, i0 = Math.floor(f), w = [];
        for (var i = 0; i < n; i++) {
          w[i] = s + (a - s) * Math.max(0, 1 - Math.abs(f - i));
          cards[i].style.flexBasis = w[i] + 'px';
        }
        for (var j = 0; j < Math.min(i0, n - 1); j++) left += w[j] + g;
        x = i0 >= n - 1 ? left : left + (f - i0) * (w[i0] + g);
        var total = 0;
        for (var t = 0; t < n; t++) total += w[t] + (t ? g : 0);
        x = Math.max(0, Math.min(x, total - W));
      } else {
        var m = W * wm / 100;
        x = Math.max(0, Math.min(f * (m + g), n * m + (n - 1) * g - W));
      }
      track.style.transform = 'translate3d(' + (-x).toFixed(1) + 'px,0,0)';
      var k = Math.max(0, Math.min(n - 1, Math.round(f)));
      setActive(Math.abs(f - k) < FERMA ? k : -1);
    }

    // ---- mobile: swipe ----
    function swStep() { return cards[0].offsetWidth + gap(); }
    function swMax() { return track.scrollWidth - track.clientWidth; }
    function swLeft(i) { return Math.min(i * swStep(), swMax()); }
    function swRead(settled) {
      var sl = track.scrollLeft, mx = swMax(), m = swStep();
      if (mx > 0 && sl >= mx - 2) return n - 1;
      var f = sl / m, k = Math.max(0, Math.min(n - 1, Math.round(f)));
      return settled || Math.abs(f - k) < FERMA ? k : -1;
    }
    track.addEventListener('scroll', function () {
      if (!swipe) return;
      setActive(swRead(false));
      clearTimeout(swT);
      swT = setTimeout(function () { setActive(swRead(true)); }, 120);
    }, { passive: true });
    function swGo(i) { track.scrollTo({ left: swLeft(i), behavior: 'smooth' }); }

    function secTop() { return pageYOffset + sec.getBoundingClientRect().top; }
    function progress() { return -sec.getBoundingClientRect().top; }
    function cardY(k) { return off0 + k * step; }
    function readTarget() { var p = progress() - off0; return p <= 0 ? 0 : p >= maxP ? n - 1 : p / step; }
    function zona() {
      var p = progress();
      H.classList.toggle('e-msc-zona', on && p >= -2 && p <= sec.offsetHeight - innerHeight + 2);
    }

    function tick() {
      loop = 0;
      if (!on) return;
      zona();
      target = readTarget();
      var d = target - fd;
      fd = Math.abs(d) < 0.002 ? target : fd + d * FOLLOW;
      render(fd);
      if (fd !== target) loop = requestAnimationFrame(tick);
    }

    // scivolamento morbido della pagina fino alla card k (annullato se si riprende a scorrere)
    function glide(k) {
      var y0 = pageYOffset, y1 = Math.round(secTop() + cardY(k)), dist = Math.abs(y1 - y0);
      if (dist < 2) return;
      var dur = Math.min(800, 320 + dist * 0.6), t0 = 0, id = ++auto;
      function f(ts) {
        if (auto !== id) return;
        if (!t0) t0 = ts;
        var q = Math.min(1, (ts - t0) / dur);
        scrollTo(0, Math.round(y0 + (y1 - y0) * ease(q)));
        if (q < 1) requestAnimationFrame(f); else auto = 0;
      }
      requestAnimationFrame(f);
    }
    function cancelGlide() { auto = 0; }
    // scroll fermo fra due card: si va sulla più vicina nella direzione dello scroll
    function settle() {
      if (!on || auto) return;
      var p = progress();
      if (p <= 0 || p >= sec.offsetHeight - innerHeight) return;
      var t = readTarget(), f = t - Math.floor(t);
      if (f < 0.01 || f > 0.99) return;
      var k = dir > 0 ? (f > SPINTA ? Math.ceil(t) : Math.floor(t)) : (f < 1 - SPINTA ? Math.floor(t) : Math.ceil(t));
      glide(Math.max(0, Math.min(n - 1, k)));
    }

    function onScroll() {
      if (!on) return;
      var y = pageYOffset;
      if (!auto) {
        if (y !== lastY) dir = y > lastY ? 1 : -1;
        lastScroll = now(); hovReset();
        clearTimeout(stopT); stopT = setTimeout(settle, STOP);
      }
      lastY = y;
      if (!loop) loop = requestAnimationFrame(tick);
    }

    function goTo(k) { if (k === cur) return; if (swipe) swGo(k); else if (on) glide(k); }

    var hovC = null, hovT = 0, hovPx = 0, mx = null, my = null;
    function hovReset() { hovC = null; hovPx = 0; clearTimeout(hovT); }
    function calmo() { return now() - lastScroll > CALMA && !auto && Math.abs(fd - target) < 0.01; }
    track.addEventListener('pointermove', function (e) {
      if (!on || !HOVER.matches || e.pointerType !== 'mouse') return;
      var dx = mx === null ? 0 : e.clientX - mx, dy = my === null ? 0 : e.clientY - my;
      mx = e.clientX; my = e.clientY;
      var dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < 1 || !calmo()) { if (dist >= 1) hovReset(); return; }
      var c = e.target.closest && e.target.closest('.e-msc__card'), i = cards.indexOf(c);
      if (i < 0 || i === cur) { hovReset(); return; }
      if (c !== hovC) { hovReset(); hovC = c; }
      hovPx += dist;
      if (hovPx < HOVER_PX) return;
      clearTimeout(hovT);
      hovT = setTimeout(function () {
        if (hovC !== c || !calmo()) { hovReset(); return; }
        var p = progress();
        if (p < -2 || p > sec.offsetHeight - innerHeight + 2) return;
        hovReset();
        goTo(i);
      }, HOVER_MS);
    });
    track.addEventListener('pointerleave', function () { hovReset(); mx = my = null; });
    // chi scorre vince: rotella, dito o tastiera fermano lo scivolamento automatico
    addEventListener('wheel', function () { hovReset(); cancelGlide(); }, { passive: true });
    addEventListener('touchstart', cancelGlide, { passive: true });
    addEventListener('keydown', cancelGlide);

    track.addEventListener('click', function (e) {
      if (!on && !swipe) return;
      var c = e.target.closest && e.target.closest('.e-msc__card'), i = cards.indexOf(c);
      if (i < 0 || i === cur) return;
      e.preventDefault();
      goTo(i);
    });

    function layout() {
      var ok = !RM.matches && n > 1;
      on = ok && DESK.matches;
      swipe = ok && !DESK.matches;
      sec.classList.toggle('is-pin', on);
      sec.classList.toggle('is-swipe', swipe);
      track.style.transition = on ? 'none' : '';
      cards.forEach(function (c) { c.style.transition = on ? 'none' : ''; if (!on) c.style.flexBasis = ''; });
      H.style.removeProperty('scroll-snap-type');
      if (!on) {
        sec.style.height = ''; track.style.transform = '';
        H.classList.remove('e-msc-zona');
        cur = -2;
        if (swipe) setActive(swRead(true));
        else cards.forEach(function (c) { c.classList.add('is-active'); });
        return;
      }
      step = Math.max(160, innerHeight * passo / 100);
      off0 = Math.round(step * SOSTA_INIZIO);
      maxP = (n - 1) * step;
      sec.style.height = (pin.offsetHeight + off0 + maxP + step * SOSTA_FINE) + 'px';
      fd = target = readTarget();
      cur = -2;
      render(fd);
      zona();
    }

    addEventListener('scroll', onScroll, { passive: true });
    var lastW = innerWidth;
    addEventListener('resize', function () {
      if (innerWidth === lastW) { if (on) render(fd); return; }
      lastW = innerWidth;
      layout();
    });
    listen(DESK, layout);
    listen(RM, layout);

    track.addEventListener('focusin', function (e) {
      vp.scrollLeft = 0;
      if (!on && !swipe) return;
      var c = e.target.closest && e.target.closest('.e-msc__card'), i = cards.indexOf(c);
      if (i >= 0 && i !== cur) goTo(i);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { sec.classList.add('is-in'); io.disconnect(); } });
      }, { threshold: 0.2 });
      io.observe(pin);
      var io2 = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        Array.prototype.forEach.call(sec.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; });
        io2.disconnect();
      }, { rootMargin: '1200px 0px' });
      io2.observe(sec);
    } else {
      sec.classList.add('is-in');
    }

    sec._sel = function (i) { if (i >= 0) goTo(i); };

    layout();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
  }

  function all(root) { Array.prototype.forEach.call((root || document).querySelectorAll('[data-e-msc]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var sec = e.target.closest && e.target.closest('[data-e-msc]');
    if (!sec || !sec._sel) return;
    sec._sel(Array.prototype.slice.call(sec.querySelectorAll('.e-msc__card')).indexOf(e.target.closest('.e-msc__card')));
  });
})();